import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { getPersonPropertyInfo } from '../utils';

import CellPersonWithImage from '../../Table/CellPersonWithImage';

const personInfoCustomStyle = {
  display: 'block',
  overflow: 'hidden',
  height: '2rem',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const CommunityMemberComponent = ({ person }) => (
  <Box mt="2rem">
    <CellPersonWithImage
      person={person}
      linkUrl={`/global-person-search/${person?.id}`}
      personInfo={getPersonPropertyInfo(person)}
      personCustomStyle={{ fontWeight: 'bold' }}
      personInfoCustomStyle={personInfoCustomStyle}
    />
  </Box>
);

CommunityMemberComponent.propTypes = {
  person: PropTypes.instanceOf(Object).isRequired,
};

export default CommunityMemberComponent;
